import { FORM_SINGLE_SCALE_ROW_VALUE } from 'types';

// The API uses a single blank row for a single question. Whitespace is equivalent;
// a named single row remains a matrix. Keep this contract until the API has a mode flag.
export const isSingleScaleRating = (options?: string[]): boolean =>
  options?.length === 1 && options[0]?.trim() === FORM_SINGLE_SCALE_ROW_VALUE;
